export default __webpack_public_path__ + "static/media/Balthus's Woodsman Gloves.e101a5de.jpg";